import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const ModalTitle = (props) => {
  const { copy } = props

  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  return (
    <div className="ModalTitle">
      <div className="ModalTitle-inner">
        {copy && (
          <div className="ModalTitle-copy">
            {copy.label && <span className="ModalTitle-label">{t(copy.label)}</span>}
            {copy.subLabel && <span className="ModalTitle-subLabel">{t(copy.subLabel)}</span>}
          </div>
        )}
      </div>
    </div>
  )
}

ModalTitle.propTypes = {
  copy: PropTypes.object
}

export default ModalTitle
